import React from "react";

const PlaceOrder = () => {
  return (
    <div>
      <iframe
        title="Order Placed"
        src="https://giphy.com/embed/9Ai5dIk8xvBm0"
        width="480"
        height="399"
        frameBorder="0"
        className="giphy-embed"
        allowFullScreen
      ></iframe>
      <p>
        <a href="https://giphy.com/gifs/mr-gif-9Ai5dIk8xvBm0">via GIPHY</a>
      </p>
    </div>
  );
};

export default PlaceOrder;
